export default __webpack_public_path__ + "static/media/logo-simplifi-full.42c1b031.svg";